import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import PikadayLoader from "../internal/PikadayLoader";
import {I18n} from "../../../../dce-i18n/lib";
import type * as Pikaday from "pikaday";
import {getScrollParent} from "dce-engine";
import {PikadayOptions} from "pikaday";

interface PikadayInputProps {
    renderInParent: boolean
}

const PIKADAY_I18N = {
    previousMonth: 'Poprzedni',
    nextMonth: 'Następny',
    months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    weekdays: ['Niedziela', 'Poniedzialek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    weekdaysShort: ['Nie', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
    format: 'YYYY-MM-DD',
    formatPlaceholder: 'YYYY-MM-DD'
};


@Dce("PikadayInput")
export default class PikadayInput extends DceComponent<PikadayInputProps> {

    private pikaday: Pikaday;

    constructor(elem: DceHTMLElement, props: PikadayInputProps) {
        super(elem, props);

        let labels = I18n.getOrElse('pikadayI18N', PIKADAY_I18N);

        PikadayLoader.load().then(value => {

            let options: PikadayOptions = {
                firstDay: 1,
                field: elem,
                format: labels['format'],
                i18n: labels
            };

            if(this.props.renderInParent){
                options.container = elem.parentElement;
                options.bound = false;
            }

            this.pikaday = new (value.PikadayClass)(options);

            if(this.props.renderInParent) {
                this.pikaday.el.style.position = 'static';
                this.pikaday.el.style.marginTop = '-1px';

                this.pikaday.show();
            }

        });

        let scrollParent = getScrollParent(elem)

        scrollParent.addEventListener('scroll', (e) => {
            this.pikaday.adjustPosition();
        });

        console.log("SCROLL PARENT", scrollParent, elem);

    }

    onRemove() {
        if (null != this.pikaday) {
            this.pikaday.el.remove();
        }
    }

    defaultProps(): Partial<PikadayInputProps> {
        return {
            renderInParent: false
        }
    }
}
